import find from 'lodash.find'
import remove from 'lodash.remove'
// import * as Sentry from "@sentry/browser";
import api from '../../../helpers/Api'
import { getDomainOrigin } from './utilsCreate'
import { urlRewrite } from "./urlsRewrite"

const isEmpty = require('lodash.isempty')
const Diff = require('diff')
const cheerio = require('cheerio')
const axios = require('axios')

const { NotificationManager } = require('../../../components/common/react-notifications')

const spanCursor = '<span id="cursor" class="added"></span>'


const getParaphraseClicked = (editorParaphrased) => {
  const node = editorParaphrased.current.selection.getNode()

  try {
    if (node.id.includes('paraphrase')) return node.id
    if (node.parentElement.id.includes('paraphrase')) return node.parentElement.id
    if (node.parentElement.parentElement.id.includes('paraphrase')) return node.parentElement.parentElement.id
  } catch (error) {
    return false
  }


  return false
}

const addHighlightedParaphrase = ({ editorParaphrased, editorOriginal }) => {
  const hasRephrasing = editorParaphrased.current.iframeElement.contentWindow.document.querySelector('.rephrasing')

  if (!hasRephrasing) {
    // limpa as paráfrases que estão marcadas como highlighted-paraphrase
    const spanEditorOriginalHighlighted = editorOriginal.current.iframeElement.contentWindow.document.querySelector('.highlighted-paraphrase')
    const spanEditorParaphrasedHighlighted = editorParaphrased.current.iframeElement.contentWindow.document.querySelector('.highlighted-paraphrase')

    if (spanEditorOriginalHighlighted) spanEditorOriginalHighlighted.classList.remove('highlighted-paraphrase')
    if (spanEditorParaphrasedHighlighted) spanEditorParaphrasedHighlighted.classList.remove('highlighted-paraphrase')

    const paraphraseClicked = getParaphraseClicked(editorParaphrased)

    if (paraphraseClicked && paraphraseClicked.includes('paraphrase-')) {
      editorParaphrased.current.iframeElement.contentWindow.document.querySelector(`#${paraphraseClicked}`).classList.add('highlighted-paraphrase')
      editorOriginal.current.iframeElement.contentWindow.document.querySelector(`.${paraphraseClicked}`).classList.add('highlighted-paraphrase')
    }
  }

}

const getCaretPosition = ({ paraphraseClicked, editorParaphrased }) => {
  let sentence = ''
  editorParaphrased.current.iframeElement.contentWindow.document.querySelector(`#${paraphraseClicked}`).childNodes.forEach((el) => {
    // se for 0, então a mudança não ocorreu dentro de um span.added
    if (el.childNodes.length === 0) {
      // se existir id = cursor, então é: <span id="cursor" class="added"></span>
      if (el.id === 'cursor') sentence += el.outerHTML
      else sentence += el.textContent
    } else {
      if (el && el.outerHTML && el.outerHTML.includes('synonyms')) {
        if (el.outerHTML.includes('added') && el.outerHTML.includes('cursor')) {
          const paraphrasedSentence = editorParaphrased.current.iframeElement.contentWindow.document.querySelector(`#${paraphraseClicked}`).textContent
          /*
          SE EXISTIR 2 PALAVRAS OU MAIS IGUAL AO SINÔNIMO EDITADO, RETIRA A PROPRIEDADE DE SINÔNIMO
          ESSE FOI O ÚNICO JEITO ENCONTRADO DE NÃO PERDER O CURSOR NA HORA DE ADICIONAR O SINÔNIMO
          EX: É pouco: 8% do total do "que" os americanos "Qquerem"
          SE FOR APAGANDO O QUEREM, ATÉ VIRAR QUE, TERIA DOIS QUE MAS UM ÚNICO SINÔNIMO, ENTÃO O SINÔNIMO
          SERIA ADICIONADO NO PRIMEIRO "QUE" E PORTANTO PERDERIA O CURSOR, POIS ESTAVA NO FINAL E IRIA PARA O MEIO DO TEXTO.
          */
          if ((paraphrasedSentence.match(new RegExp(`\\W${el.textContent}\\W`, 'g')) || []).length > 1) {
            const $ = cheerio.load(el.innerHTML)
            sentence += $('.synonyms').html()
          } else {
            const $ = cheerio.load(el.outerHTML)
            if (isEmpty($('.synonyms').html())) {
              sentence += el.innerHTML }
            else {
              if ($('.added').length > 1) {
                $('.synonyms').each(function () {
                  $(this).replaceWith($(this).html())
                });
                sentence += $('.added').html()
              }
              else sentence += $('.synonyms').html()
            }
          }
        } else if (el.outerHTML.includes('cursor')) sentence += el.innerHTML
        else sentence += el.textContent
      }
      else sentence += el.innerHTML
    }
  })

  // ESSE REGEX É NECESSÁRIO POIS O PRÓPRIO TINYMCE BUGA O CÓDIGO, ENTÃO AO SELECIONAR PALAVRAS
  // QUE ESTÃO COM SUBLINHADO (PALAVRAS COM SINÔNIMOS) OU NEGRITO (PALAVRAS ALTERADAS) NO CSS
  // console.log('sentence:', sentence)
  sentence = sentence.replaceAll('&nbsp;', ' ').replaceAll(/(<b>|<\/b>|<u>|<\/u>)/g, '')
  return sentence.indexOf(spanCursor)
}

let editorParaphrasedContent = ''
const diffTextOnChangeText = ({ editorOriginal, editorParaphrased, paraphraseID }) => {
  try {
    let paraphraseClicked = ''
    if (!isEmpty(paraphraseID)) paraphraseClicked = paraphraseID
    // isso é útil pois as vezes nenhuma sentença está selecionada, mas ao trocar de aba ou programa, essa função é chamada e ocorre erro
    else if (editorParaphrased.current.iframeElement.contentWindow.document.querySelector('.highlighted-paraphrase') === null) return
    else paraphraseClicked = editorParaphrased.current.iframeElement.contentWindow.document.querySelector('.highlighted-paraphrase').id

    if (!isEmpty(paraphraseClicked) && editorParaphrasedContent !== editorParaphrased.current.getContent(editorParaphrased.current.getBody())) {
      const originalSentence = editorOriginal.current.iframeElement.contentWindow.document.querySelector(`.${paraphraseClicked}`).textContent
      let paraphrasedSentence = editorParaphrased.current.iframeElement.contentWindow.document.querySelector(`#${paraphraseClicked}`).textContent

      const paraphrasedSentenceHTML = editorParaphrased.current.iframeElement.contentWindow.document.querySelector(`#${paraphraseClicked}`).innerHTML
      const $ = cheerio.load(paraphrasedSentenceHTML)
      let synonyms = []
      $('.synonyms').each(function (i, elem) {
        // caso seja um sinônimo composto (ex: "sinônimo composto"), troca por uma palavra única que será convertida posteriormente
        // se isso não for feito, o sinônimo deixa de ser sinônimo e vira um texto comum
        let html = $(this).html($(this)).html()
        const innerHTML = cheerio.load(html, null, false)('.synonyms').html()
        let synonymChangedFirstLetter = paraphrasedSentenceHTML.match(new RegExp(`[-'0-9a-zÀ-ÿ]+<span id="cursor" class="added"></span>${html}`, 'g'))

        if ($(this).text().trim().split(' ').length > 1) {
          // Corrige erro de juntar um SINONIMO COMPOSTO com outra palavra
          // Antes ficaria ex: uma nota técnica, ao juntar ficaria SINONIMOCOMPOSTO1técnica
          // com esse IF abaixo, fica uma notatécnica, não dando mais erro do SINONIMOCOMPOSTO
          if ((paraphrasedSentence.match(new RegExp(`\\W${$(this).text().trim()}\\W`)) || []).length >= 1) {
            paraphrasedSentence = paraphrasedSentence.replace(new RegExp(`\\W${$(this).text().trim()}\\W`), ` SINONIMOCOMPOSTO${i} `)
          } else if ((paraphrasedSentence.match(new RegExp(`^${$(this).text().trim()}\\W`)) || []).length >= 1) {
            paraphrasedSentence = paraphrasedSentence.replace(new RegExp(`^${$(this).text().trim()}\\W`), `SINONIMOCOMPOSTO${i} `)
          }
          synonyms.push({
            synonym: `SINONIMOCOMPOSTO${i}`, id: elem.attribs.id, html, innerHTML
          })
        } else {
          if (isEmpty(synonymChangedFirstLetter)) {
            if (html.includes(`${$(this).text().trim()}&nbsp;${spanCursor}`)) html = html.replace(`&nbsp;${spanCursor}`, '')
            if (html.includes(`${$(this).text().trim()} ${spanCursor}`)) {
              html = html.replace(` ${spanCursor}`, '')
              html += ` ${spanCursor}`
            }

            synonyms.push({
              synonym: $(this).text().trim(), id: elem.attribs.id, html, innerHTML
            })
          } else {
            // Se foi digitado uma letra antes da palavra com sinônimo
            synonymChangedFirstLetter = synonymChangedFirstLetter.join('')

            const [inicialLetter, synonymChanged] = synonymChangedFirstLetter.split(spanCursor)

            const synonymWithSpanCursor = inicialLetter + spanCursor + $(this).text().trim()
            synonyms.push({
              synonym: inicialLetter + $(this).text().trim(),
              id: elem.attribs.id,
              html: synonymChanged.replace($(this).text().trim(), synonymWithSpanCursor),
              innerHTML: synonymWithSpanCursor
            })
          }
        }
      })

      // LIMPA SINÔNIMOS, CASO TIVER 1 SINÔNIMO MAS DUAS OCORRÊNCIA DA PALAVRA, ENTÃO EXCLUI O SINÔNIMO
      synonyms = synonyms.filter(syn => (paraphrasedSentence.match(new RegExp(`\\W${syn.synonym}\\W|${syn.synonym}\\W`, 'g')) || []).length === 1)

      const diff = Diff.diffWords(originalSentence.trim(), paraphrasedSentence.trim())

      let leftSentenceWithDiff = ''
      let rightSentenceWithDiff = ''

      const positionCursor = getCaretPosition({ paraphraseClicked, editorParaphrased })

      const countChars = []
      let mustCountChars = true
      diff.forEach((part) => {
        if (part.removed) leftSentenceWithDiff += `<span class="removed">${part.value}</span>`
        else if (part.added) {
          // caso for sinônimo composto, conta countChars a partir do sinônimo, e não do value, já que ele está alterado (SINONIMOCOMPOSTO1)
          let synonym = find(synonyms, (syn) => syn.synonym == part.value)
          if (mustCountChars && synonym) countChars.push(synonym.html.replace(/<[^>]*>?/gm, '').trim().length)
          else countChars.push(part.value.length)

          const diferenca = countChars.reduce((a, b) => a + b, 0) - positionCursor

          if (diferenca >= 0 && mustCountChars) {
            const charsPartValue = part.value.split('')
            // entra nessa condição caso for alterado a letra inicial de palavra com sinônimos, ex: gravou para Ggravou
            synonym = find(synonyms, (syn) => syn.synonym == part.value.substring(1))
            if (synonym) {
              charsPartValue.splice(charsPartValue.length - diferenca, 0, spanCursor)
              remove(synonyms, (syn) => syn.id === synonym.id)
              rightSentenceWithDiff += `<span class="added">${synonym.html.replace(part.value.substring(1), charsPartValue.join(''))}</span>`
              mustCountChars = false
            } else if (find(synonyms, (syn) => syn.synonym == part.value)) {
              synonym = find(synonyms, (syn) => syn.synonym == part.value)
              remove(synonyms, (syn) => syn.id === synonym.id)
              rightSentenceWithDiff += `<span class="added">${synonym.html}</span>`
              mustCountChars = false
            } else {
              let partValue = charsPartValue.join('')
              charsPartValue.splice(charsPartValue.length - diferenca, 0, spanCursor)

              const words = charsPartValue.join('').replace('<span id="cursor" class="added"></span>', '').split(/\s(?![^<]*>)/g)
              const wordsHasSynonyms = []
              words.forEach((word) => {
                const wordWithoutPunctuation = word.replace(/[.,\/#!$%\^&\*;:{}=\_`~()]/g, "")
                synonym = find(synonyms, (syn) => syn.synonym == wordWithoutPunctuation)
                if (synonym) wordsHasSynonyms.push(wordWithoutPunctuation)
              })

              if (wordsHasSynonyms.length > 0) {
                if (partValue.includes('SINONIMOCOMPOSTO')) partValue = charsPartValue.join('').replace('<span id="cursor" class="added"></span>', '')
                else partValue = charsPartValue.join('')
                // O REGEX ANTES ERA COM \w, assim: \w+(<span[^>]*>)|<\/?span[^>]*>\w+
                // Porém, se a palavra tivesse acento, dava erro, então foi necessário trocar \w+ por [-'0-9a-zÀ-ÿ]+
                const wordWithSpanCursor = (partValue.match(new RegExp(/[-'0-9a-zÀ-ÿ]+(<span[^>]*>)|<\/?span[^>]*>[-'0-9a-zÀ-ÿ]+/, 'g')) || []).join('')
                wordsHasSynonyms.forEach(word => {
                  synonym = find(synonyms, (syn) => syn.synonym == word)
                  remove(synonyms, (syn) => syn.id === synonym.id)
                  if (word == wordWithSpanCursor.replace(spanCursor, '')) partValue = partValue.replace(wordWithSpanCursor, synonym.html)
                  else partValue = partValue.replace(word, synonym.html)
                })
                rightSentenceWithDiff += `<span class="added">${partValue}</span>`

              } else {
                // adicione o spanCursor na palavra que foi modificada. Ex: come, mudou para codme, então ficou cod<span id="cursor" class="added"></span>me
                charsPartValue.splice(charsPartValue.length - diferenca, 0, spanCursor)
                rightSentenceWithDiff += `<span class="added">${charsPartValue.join('')}</span>`
              }
              mustCountChars = false
            }
          } else {
            const charsPartValue = part.value.split('')

            const words = charsPartValue.join('').replace('<span id="cursor" class="added"></span>', '').split(' ')
            const wordsHasSynonyms = []
            words.forEach((word) => {
              const wordWithoutPunctuation = word.replace(/[.,\/#!$%\^&\*;:{}=\_`~()]/g, "")
              synonym = find(synonyms, (syn) => syn.synonym == wordWithoutPunctuation)
              if (synonym) wordsHasSynonyms.push(wordWithoutPunctuation)
            })

            if (wordsHasSynonyms.length > 0) {
              let partValue = part.value
              wordsHasSynonyms.forEach(word => {
                synonym = find(synonyms, (syn) => syn.synonym == word)
                remove(synonyms, (syn) => syn.id === synonym.id)
                partValue = partValue.replace(word, synonym.html)
              })
              rightSentenceWithDiff += `<span class="added">${partValue}</span>`

            } else {
              // adicione o spanCursor na palavra que foi modificada. Ex: come, mudou para codme, então ficou cod<span id="cursor" class="added"></span>me
              rightSentenceWithDiff += `<span class="added">${part.value}</span>`
            }
          }
        } else {
          // caso for sinônimo composto, conta countChars a partir do sinônimo, e não do value, já que ele está alterado (SINONIMOCOMPOSTO1)
          let synonym = find(synonyms, (syn) => syn.synonym == part.value)
          if (mustCountChars && synonym) countChars.push(synonym.html.replace(/<[^>]*>?/gm, '').trim().length)
          else countChars.push(part.value.length)

          leftSentenceWithDiff += part.value
          const diferenca = countChars.reduce((a, b) => a + b, 0) - positionCursor

          if (diferenca >= 0 && mustCountChars) {
            const charsPartValue = part.value.split('')
            charsPartValue.splice(charsPartValue.length - diferenca, 0, spanCursor)


            const words = charsPartValue.join('').replace('<span id="cursor" class="added"></span>', '').split(/\s(?![^<]*>)/g)

            const wordsHasSynonyms = []
            words.forEach((word) => {
              const wordWithoutPunctuation = word.replace(/[.,\/#!$%\^&\*;:{}=\_`~()]/g, "")
              synonym = find(synonyms, (syn) => syn.synonym == wordWithoutPunctuation)
              if (synonym) wordsHasSynonyms.push(wordWithoutPunctuation)
            })

            if (wordsHasSynonyms.length > 0) {
              let partValue = charsPartValue.join('')
              wordsHasSynonyms.forEach(word => {
                synonym = find(synonyms, (syn) => syn.synonym == word)
                remove(synonyms, (syn) => syn.id === synonym.id)
                // Se terminar com spanCursor, significa que o sinônimo foi alterado para a palavra original
                if (synonym.innerHTML.endsWith(spanCursor)) partValue = partValue.replace(synonym.innerHTML.replace('&nbsp;', '').replace(spanCursor, ''), synonym.html)
                else if (synonym.innerHTML.includes(spanCursor)) {
                  if (partValue.includes(synonym.synonym)) partValue = partValue.replace(synonym.synonym, synonym.html)
                  else if (partValue.includes(synonym.innerHTML)) partValue = partValue.replace(synonym.innerHTML, synonym.html)
                }
                else partValue = partValue.replace(synonym.innerHTML, synonym.html)
              })
              rightSentenceWithDiff += partValue

            } else {
              charsPartValue.splice(charsPartValue.length - diferenca, 0, spanCursor)
              rightSentenceWithDiff += charsPartValue.join('')
            }
            mustCountChars = false

          } else {
            let words = part.value.split(/\s/g)

            words = words.map((word) => {
              if (word.length === 1 && !!word.match(/^[.,:;!?)(\][]/)) return word

              let lastChar = ''
              let firstChar = ''
              if (!isEmpty(word) && !!word.slice(-1).match(/^[.,:;!?)(\][]/)) {
                lastChar = word.slice(-1)
                word = word.slice(0, -1)
              }
              if (!isEmpty(word) && !!word[0].match(/^[.,:;!?)(\][]/)) {
                firstChar = word[0]
                word = word.substring(1)
              }

              synonym = find(synonyms, (syn) => syn.synonym == word)
              if (synonym) {
                remove(synonyms, (syn) => syn.id === synonym.id)
                return firstChar + synonym.html + lastChar
              }

              return firstChar + word + lastChar
            })

            rightSentenceWithDiff += words.join(' ')
          }
        }
      })

      // verifica se paraphrasedSentenceHTML originalmente possui ponto final, e caso sim, adiciona ao final de rightSentenceWithDiff
      rightSentenceWithDiff = rightSentenceWithDiff.trim()
      const rightSentenceWithDiffString = rightSentenceWithDiff.trim().replace(/<[^>]*>?/gm, '').trim()
      if (originalSentence.trim().charAt(originalSentence.trim().length - 1) === '.' && rightSentenceWithDiffString.charAt(rightSentenceWithDiffString.length - 1) !== '.') rightSentenceWithDiff += '.'

      editorOriginal.current.iframeElement.contentWindow.document.querySelector(`.${paraphraseClicked}`).innerHTML = leftSentenceWithDiff
      editorParaphrased.current.iframeElement.contentWindow.document.querySelector(`#${paraphraseClicked}`).innerHTML = rightSentenceWithDiff

      removeSynonymsList(editorParaphrased)

      const dom = editorParaphrased.current.dom
      const cursor = dom.select('span[id="cursor"]')[0]
      editorParaphrased.current.selection.setCursorLocation(cursor)
      dom.remove('cursor')
      editorParaphrasedContent = editorParaphrased.current.getBody().innerHTML.replace(spanCursor, '')

    }
  } catch (e) {
    console.log('e:', e)
    // Sentry.captureException(e)
    console.log('editorOriginal:', editorOriginal.current.getBody().innerHTML)
    console.log('editorParaphrased:', editorParaphrased.current.getBody().innerHTML)
    // Sentry.captureMessage(`method name: ${diffTextOnChangeText.name}`)
  }
}

const rephraseSentence = async (editorOriginal, editorParaphrased, paraphrases, setParaphrases, setSynonymsRephrase, clientRef) => {
  const hasRephrasing = editorParaphrased.current.iframeElement.contentWindow.document.querySelector('.rephrasing')

  // verifica se não tem nenhuma frase sendo gerada nesse exato momento, caso tiver não gera novamente
  if (!hasRephrasing) {
    let paraphraseClicked = getParaphraseClicked(editorParaphrased)
    const hasHighlightParaphrase = editorOriginal.current.iframeElement.contentWindow.document.querySelector('.highlighted-paraphrase')

    let originalPhrase
    if (!isEmpty(paraphraseClicked) && paraphraseClicked.includes('paraphrase-')) originalPhrase = editorOriginal.current.iframeElement.contentWindow.document.querySelector(`.${paraphraseClicked}`).textContent
    else if (hasHighlightParaphrase !== null) {
      originalPhrase = editorOriginal.current.iframeElement.contentWindow.document.querySelector('.highlighted-paraphrase').textContent
      paraphraseClicked = Array.from(editorOriginal.current.iframeElement.contentWindow.document.querySelector('.highlighted-paraphrase').classList).find(className => className.includes('paraphrase-'))
    } else if (isEmpty(originalPhrase)) NotificationManager.error('Selecione a frase que deseja reescrever')


    if (!isEmpty(originalPhrase)) {
      editorParaphrased.current.setMode('readonly')
      editorParaphrased.current.iframeElement.contentWindow.document.querySelector('.highlighted-paraphrase').classList.add('rephrasing')


      if (clientRef.current) {
        clientRef.current.send(JSON.stringify({ text: originalPhrase }));
    }

    }
  }
}

const undoPhrase = (editorOriginal, editorParaphrased) => {

  if (editorParaphrased.current.iframeElement.contentWindow.document.querySelector('.highlighted-paraphrase') === null) {
    NotificationManager.error('Selecione a sentença que deseja retornar ao texto original')
    return
  }

  const paraphrasedClicked = editorParaphrased.current.iframeElement.contentWindow.document.querySelector('.highlighted-paraphrase').id

  const originalPhrase = editorOriginal.current.iframeElement.contentWindow.document.querySelector(`.${paraphrasedClicked}`).textContent

  editorParaphrased.current.iframeElement.contentWindow.document.querySelector(`#${paraphrasedClicked}`).innerHTML = originalPhrase
  editorOriginal.current.iframeElement.contentWindow.document.querySelector(`.${paraphrasedClicked}`).innerHTML = originalPhrase
}

const copyTextToClipboard = (editorParaphrased) => {
  const text = editorParaphrased.current.getContent({ format: "text" });
  navigator.clipboard.writeText(text).then(() => {
    NotificationManager.primary('Text was copied to the clipboard')
  }, (err) => {
    console.log('err:', err)
    NotificationManager.error('An error occurred while copying the text')
  })
}

const copyParaphraseToClipboard = (editorParaphrased) => {

  if (editorParaphrased.current.iframeElement.contentWindow.document.querySelector('.highlighted-paraphrase') === null) {
    NotificationManager.error('Selecione a sentença que deseja copiar para área de transferência, ou utilize o botão inferior direito para copiar todo o texto.')
    return
  }

  const paraphraseClicked = editorParaphrased.current.iframeElement.contentWindow.document.querySelector('.highlighted-paraphrase').id
  const paraphrasedSentence = editorParaphrased.current.iframeElement.contentWindow.document.querySelector(`#${paraphraseClicked}`).textContent
  navigator.clipboard.writeText(paraphrasedSentence).then(() => {
    NotificationManager.primary('Text was copied to the clipboard')
  }, (err) => {
    console.log('err:', err)
    NotificationManager.error('An error occurred while copying the text')
  })
}

const removeSynonymsList = (editorParaphrased) => {
  // editorParaphrased.current.dom.remove('cursor')
  // editorParaphrasedContent = editorParaphrased.current.getBody().innerHTML.replace(spanCursor, '')
  editorParaphrased.current.dom.remove(editorParaphrased.current.dom.select('div[class="synonyms-list"]'))
}

const removeRephraseTools = (editorParaphrased) => {
  editorParaphrased.current.dom.remove(editorParaphrased.current.dom.select('div[class="rephrase-tools"]'))
}

const changeSynonym = (editorParaphrased, editorOriginal, event) => {
  if (event.target.dataset.index) {
    editorParaphrased.current.iframeElement.contentWindow.document.querySelector(`#synonym-${event.target.dataset.index}`).innerHTML = event.target.innerText + spanCursor
    diffTextOnChangeText({ editorOriginal, editorParaphrased })
  }
}

const rephrase = (editorParaphrased, editorOriginal, paraphrases, setParaphrases, setSynonymsRephrase, trial, event) => {
  if ((event.target && event.target && event.target.id === "rephrase")
  || (event.srcElement && event.srcElement.currentSrc && event.srcElement.currentSrc.includes('rephrase.svg'))) {
    rephraseSentence(editorOriginal, editorParaphrased, paraphrases, setParaphrases, setSynonymsRephrase, trial)
    removeRephraseTools(editorParaphrased)
  } else if ((event.target && event.target && event.target.id === "undo")
  || (event.srcElement && event.srcElement.currentSrc && event.srcElement.currentSrc.includes('undo.svg'))) {
    undoPhrase(editorOriginal, editorParaphrased)
    removeRephraseTools(editorParaphrased)
  } else if ((event.target && event.target && event.target.id === "copy")
  || (event.srcElement && event.srcElement.currentSrc && event.srcElement.currentSrc.includes('copy.svg'))) {
    copyParaphraseToClipboard(editorParaphrased)
    removeRephraseTools(editorParaphrased)
  }
}

const addSynonymsList = (editorParaphrased, editorOriginal, synonyms, event) => {
  const synonymsIndex = event.target.id.split('-')[1]
  synonyms = synonyms[synonymsIndex]

  // é importante para não manter várias caixa de sinônimas abertas ao mesmo tempo
  removeSynonymsList(editorParaphrased)
  removeRephraseTools(editorParaphrased)

  let innerHTML = editorParaphrased.current.iframeElement.contentWindow.document.activeElement.innerHTML
  innerHTML += '<div class="synonyms-list">'
  innerHTML += synonyms.map(synonym => `<span data-index="${synonymsIndex}" class="synonym">${synonym}</span>`).join().replaceAll(',', '')
  innerHTML += '</div>'
  editorParaphrased.current.iframeElement.contentWindow.document.activeElement.innerHTML = innerHTML

  editorParaphrased.current.selection.setCursorLocation(editorParaphrased.current.dom.select('span[id="cursor"]')[0])
  editorParaphrased.current.dom.remove('cursor')
  editorParaphrasedContent = editorParaphrased.current.getBody().innerHTML.replace(spanCursor, '')

  // Adicione eventos para os sinônimos
  editorParaphrased.current.once('click', (e) => { changeSynonym(editorParaphrased, editorOriginal, e) })

  // define posição da caixa de sinônimos um pouco abaixo da palavra selecionada
  const el = editorParaphrased.current.iframeElement.contentWindow.document.querySelector('.synonyms-list')
  const { left, top } = editorParaphrased.current.iframeElement.contentWindow.document.querySelector(`#synonym-${synonymsIndex}`).getBoundingClientRect()
  el.style.left = `${left}px`

  const editorParaphrasedScrollTop = editorParaphrased.current.iframeElement.contentWindow.document.scrollingElement.scrollTop
  el.style.top = `${editorParaphrasedScrollTop + top + 18}px` // 18 seria por causa do tamanho da fonte
  // TODO: talvez seja necessário corrigir o 18 pra quando for h1 que a fonte for maior
}

const addRephraseTools = (editorParaphrased, editorOriginal, paraphrases, setParaphrases, setSynonymsRephrase, trial) => {
  const paraphraseClicked = getParaphraseClicked(editorParaphrased)

  // console.log('innerHTML0:', editorParaphrased.current.iframeElement.contentWindow.document.activeElement.innerHTML)
  const { startOffset, endOffset } = editorParaphrased.current.selection.getRng()
  // console.log('selection):', editorParaphrased.current.selection)
  // console.log('getBoundingClientRect():', editorParaphrased.current.selection.getBoundingClientRect())
  if (startOffset === endOffset) {
    editorParaphrased.current.dom.remove('cursor') // remove todos cursor que possa existir
    editorParaphrased.current.selection.setContent(spanCursor) // adiciona o cursor
  }

  let left
  let top
  if (editorParaphrased.current.iframeElement.contentWindow.document.querySelector(`#cursor`)) {
    left = editorParaphrased.current.iframeElement.contentWindow.document.querySelector(`#cursor`).getBoundingClientRect().left
    top = editorParaphrased.current.iframeElement.contentWindow.document.querySelector(`#cursor`).getBoundingClientRect().top
  } else {
    return
    // left = editorParaphrased.current.selection.getBoundingClientRect().left
    // top = editorParaphrased.current.selection.getBoundingClientRect().top
  }

  removeRephraseTools(editorParaphrased)

  if (paraphraseClicked) {
    let innerHTML = editorParaphrased.current.iframeElement.contentWindow.document.activeElement.innerHTML
    innerHTML += '<div class="rephrase-tools">'
    innerHTML += `<div class="flex-container">
                    <div id="undo" class="flex-child visible" title="Frase Original">
                      <img src="/assets/img/tools/undo.svg" />
                    </div>
                    <div id="rephrase" class="flex-child" title="Reformular Frase">
                      <img src="/assets/img/tools/rephrase.svg" />
                    </div>
                    <div id="copy" class="flex-child" title="Copiar Frase">
                      <img src="/assets/img/tools/copy.svg" />
                    </div>
                  </div>`
    innerHTML += '</div>'
    editorParaphrased.current.iframeElement.contentWindow.document.activeElement.innerHTML = innerHTML

    editorParaphrased.current.selection.setCursorLocation(editorParaphrased.current.dom.select('span[id="cursor"]')[0])
    editorParaphrased.current.dom.remove('cursor')
    editorParaphrasedContent = editorParaphrased.current.getBody().innerHTML.replace(spanCursor, '')

    // Adicione eventos para os sinônimos
    editorParaphrased.current.once('click', (e) => { rephrase(editorParaphrased, editorOriginal, paraphrases, setParaphrases, setSynonymsRephrase, trial, e) })

    // define posição da caixa de reformular
    const el = editorParaphrased.current.iframeElement.contentWindow.document.querySelector('.rephrase-tools')

    const { innerWidth } = editorParaphrased.current.iframeElement.contentWindow
    if (left < 60) {
      el.style.left = `${10}px`
    } else {
      if (left < (innerWidth - 60)) {
        el.style.left = `${left - 52}px`
      } else {
        el.style.left = `${left - (left - innerWidth + 120)}px`
      }
    }

    const editorParaphrasedScrollTop = editorParaphrased.current.iframeElement.contentWindow.document.scrollingElement.scrollTop
    el.style.top = `${editorParaphrasedScrollTop + top - 38}px` // 18 seria por causa do tamanho da fonte
  }

}

const fixEntityEncoding = (text) => {
  text = text.replaceAll('&', '&amp;')
  text = text.replaceAll('<', '&lt;')
  text = text.replaceAll('>', '&gt;')
  return text
}

export {
  addHighlightedParaphrase,
  diffTextOnChangeText,
  getParaphraseClicked,
  undoPhrase,
  rephraseSentence,
  copyTextToClipboard,
  copyParaphraseToClipboard,
  addSynonymsList,
  addRephraseTools,
  removeSynonymsList,
  removeRephraseTools,
  fixEntityEncoding
}
